export default "/kiban/_next/static/images/bottom_black-e78a12ffb80b74a26fbafb93d11378ce.png";